<template>
  <div>
    <div class="com-model m-b-15" v-if="account">
      <div class="main-top flex flex-between">
        <div class="title">公司账户</div>
        <div class="edit-btn" @click="goModifyjypwd" v-if="account">
          <span>{{account.isSetPayPwd*1 > 0 ? '修改支付密码':'设置支付密码'}}</span>
        </div>
      </div>
      <div class="top-bottom flex flex-between">
        <div class="flex">
          <div class="label">账户余额</div>
          <div class="value" style="color: #FF7A45;">{{account.availableFunds}}</div>
          <div class="primary-btn" @click="gorecharge">立即充值</div>
        </div>
        <div class="flex">
          <div class="label">可开票金额</div>
          <div class="value">{{account.availableFunds}}</div>
          <router-link to="/index/finance/invoice/list" class="primary-btn" @click="gorecharge">索取发票</router-link>
        </div>
        <div class="flex">
          <div class="label">已支出</div>
          <div class="value">{{account.totalOutFunds}}</div>
        </div>
        <div class="flex">
          <div class="label">冻结中</div>
          <div class="value">{{account.freezeFunds}}</div>
        </div>
      </div>
    </div>
    <div class="com-model main-cont">
      <div class="title">交易记录</div>
      <div class="tab-list flex">
        <div class="tab-item" :class="{active:tabindex === 0}" @click="switchTab(0)">消费记录</div>
        <div class="tab-item" :class="{active:tabindex === 1}" @click="switchTab(1)">充值记录</div>
      </div>
      <div class="tab-cont" v-show='tabindex === 0'>
        <div class="query-cont flex">
          <div class="" style="margin-right: 72px;">
            <div class="label">查询时间</div>
            <div class="value flex">
              <el-date-picker class="query-time" size="large"
                              v-model="value1" @change="value1Time"
                              type="datetime"
                              placeholder="开始时间"/>
              <span style="font-size: 16px; margin: 0 12px; color: #333;">至</span>
              <el-date-picker class="query-time" size="large"
                              v-model="value2" @change="value2Time"
                              type="datetime"
                              placeholder="结束时间"/>
            </div>
          </div>
          <div class="" style="margin-right: 44px;">
            <div class="label">款项类型</div>
            <div class="value" style="width: 170px;">
              <el-select class="my-select" v-model="accountType" placeholder="请选择">
                <el-option :label="item.name" :value="item.id" v-for="item in accoutTypetList" :key="item.id"/>
              </el-select>
            </div>
          </div>
          <div>
            <div class="label">款项状态</div>
            <div class="value">
              <el-select class="my-select" v-model="carSub" placeholder="请选择">
                <el-option :value="1" label="已完成"/>
                <el-option :value="0" label="冻结中"/>
                <el-option :value="-1" label="未完成"/>
              </el-select>
            </div>
          </div>
        </div>
        <el-table :data="pageAccountOutCome" style="width: 100%;">
          <el-table-column prop="createdAt" label="时间" min-width="120"/>
          <el-table-column prop="sn" label="订单号" min-width="120"/>
          <el-table-column prop="funds" label="支付金额" min-width="120"/>
          <el-table-column prop="payer" label="支付人" min-width="120"/>
          <el-table-column prop="payee" label="收款方" min-width="120"/>
          <el-table-column prop="type" label="款项名称" min-width="120"/>
        </el-table>
      </div>
      <div class="tab-cont" v-show="tabindex === 1">
        <div class="query-cont flex">
          <div class="" style="margin-right: 72px;">
            <div class="label">查询时间</div>
            <div class="value flex">
              <el-date-picker class="query-time" size="large"
                              v-model="value1" @change="value3Time"
                              type="datetime"
                              placeholder="开始时间"/>
              <span style="font-size: 16px; margin: 0 12px; color: #333;">至</span>
              <el-date-picker class="query-time" size="large"
                              v-model="value2" @change="value4Time"
                              type="datetime"
                              placeholder="结束时间"/>
            </div>
          </div>
        </div>
        <el-table :data="pageAccountInCome" style="width: 100%;">
          <el-table-column prop="createdAt" label="时间" min-width="120"/>
          <el-table-column prop="sn" label="订单号" min-width="120"/>
          <el-table-column prop="funds" label="支付金额" min-width="120"/>
          <el-table-column prop="payer" label="支付人" min-width="120"/>
          <el-table-column prop="payChannel" label="支付方式" min-width="120"/>
        </el-table>
      </div>
      <el-pagination v-show="total"
                     @size-change="handleSizeChange"
                     @current-change="currentChange"
                     :current-page="pageNum"
                     :page-sizes="[10, 20, 30, 40]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"
                     style="padding-bottom: 40px;"/>
    </div>
  </div>
</template>

<script>
  const qs = require('qs');

  export default {
    data() {
      return {
        pageSize: 10,
        account: null,
        pageAccountInCome: [],// 充值记录
        pageAccountOutCome: [],// 消费记录
        tabindex: 0,
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        startDateOutCome: '',
        endDateOutCome: '',
        startDateInCome: '',
        endDateInCome: '',
        accoutTypetList: '', // 账户消费类型
        accountType: '',
        totalOutCome: 0,
        totalInCome: 0,
        pageNum: 1,
        total: -1,
        carSub: 1
      }
    },
    created() {
      this.getAccount();
      this.getAccountOutType();
      let tab = this.$route.query.tab;
      if (tab) {
        this.tabindex = 1;
      }
      this.switchTabList();
    },
    watch: {
      accountType() {
        this.getPageAccountOutCome();
      },
      carSub() {
        this.getPageAccountOutCome();
      }
    },
    methods: {
      switchTab(val) {
        this.tabindex = val;
        this.pageNum = 0;
        this.switchTabList();
      },
      switchTabList() {
        if (this.tabindex === 0) {
          this.getPageAccountOutCome();
        } else {
          this.getPageAccountInCome();
        }
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.switchTabList();
      },
      currentChange(val) {
        this.pageNum = val;
        this.switchTabList();
      },
      // 获取账户消费列表
      getAccountOutType() {
        let url = '/wapi/baseData/listAccountOutType';
        this.axios.get(url).then(res => {
          this.accoutTypetList = res.data;
        });
      },
      value1Time(val) {
        this.startDateOutCome = val;
        this.getPageAccountOutCome();
      },
      value2Time(val) {
        this.endDateOutCome = val;
        this.getPageAccountOutCome();
      },
      value3Time(val) {
        this.startDateInCome = val;
        this.getPageAccountInCome();
      },
      value4Time(val) {
        this.endDateInCome = val;
        this.getPageAccountInCome();
      },
      gorecharge() {
        this.$router.push({ path: '/index/finance/recharge' });
      },
      goModifyjypwd() {
        this.$router.push({ path: '/index/finance/modifyjypwd' });
      },
      getAccount() {
        let url = '/wapi/company/getAccount';
        this.axios.get(url).then(res => {
          this.account = res.data;
        });
      },
      // 充值记录
      getPageAccountInCome() {
        let url = `/wapi/company/pageAccountInCome?startDate=${this.startDateInCome}&endDate=${this.endDateInCome}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`;
        this.axios.get(url).then(res => {
          this.pageAccountInCome = res.rows;
          this.totalInCome = res.sum;
          this.total = res.total;
        });
      },
      // 消费记录
      getPageAccountOutCome() {
        let url = `/wapi/company/pageAccountOutCome`;
        let qdata = {
          startDate: this.startDateOutCome,
          endDate: this.endDateOutCome,
          type: this.accountType,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          status: this.carSub
        };
        //let url = `/wapi/company/pageAccountOutCome?startDate=${this.startDateOutCome}&endDate=${this.endDateOutCome}&type=${this.accountType}&pageNum=${this.pageNum}`;
        this.axios.post(url, qs.stringify(qdata)).then(res => {
          this.pageAccountOutCome = res.rows;
          this.totalOutCome = res.sum;
          this.total = res.total;
        });
      }
    }
  }
</script>

<style scoped lang="less">
  @import url('../../assets/less/base.less');
  // @import "../../assets/css/variable";
  // @import "../../assets/css/finance";
  .com-model {
    border-radius: 10px;
  }

  .title {
    color: rgba(0, 0, 0, 0.85);
    font-size: 20px;
  }

  .main-top {
    height: 86px;
    border-bottom: #D2D2D2 1px solid;
    padding: 0 24px;
    font-size: 20px;

    .edit-btn {
      color: #057CF9;
      cursor: pointer;
    }
  }

  .top-bottom {
    padding: 33px 24px 20px;

    .label {
      font-size: 16px;
      color: #999999;
      margin-right: 12px;
    }

    .value {
      font-size: 34px;
      color: #555555;
      margin-right: 12px;
    }

    .primary-btn {
      width: 100px;
      height: 40px;
      line-height: 40px;
    }
  }

  .main-cont {
    padding-top: 30px;

    .title {
      padding-left: 24px;
      margin-bottom: 46px;
    }

    .tab-list {
      border-bottom: 4px solid #EDF6FF;
      padding-left: 48px;

      .tab-item {
        margin-right: 20px;
        padding: 0 13px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        color: #555555;
        cursor: pointer;

        &.active {
          background: #EDF6FF;
          color: #057CF9;
        }
      }
    }
  }

  .tab-cont {
    padding: 54px 24px;

    .query-cont {
      margin-bottom: 49px;

      .label {
        font-size: 16px;
        color: #333333;
        margin-bottom: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// finance.vue?a3a4f326